"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isVar;

var _generated = require("./generated");

var _constants = require("../constants");

function isVar(node) {
  return (0, _generated.isVariableDeclaration)(node, {
    kind: "var"
  }) && !node[_constants.BLOCK_SCOPED_SYMBOL];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/types/lib/validators/isVar.js
// module id = bDsn
// module chunks = 0